// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_PRODUCTOFPROJECT_ACCOUNTANT } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

const api = new APIClient();

interface Product {
  productId: number;
  productName: string;
  count: number;
  wholePrice: number;
}

interface Products {
  projectProducts: Product[];
}

let val: Products;

const useFetchProduct = (id: any) => {
  const [projectProducts, setData] = useState(val);
  const [loadingProduct, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_PRODUCTOFPROJECT_ACCOUNTANT, { projectId: id })
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  // console.log(data);
  return {
    projectProducts,
    loadingProduct,
  };
};

export default useFetchProduct;
